export var paramValidatorError = function (type, message) {
    return new Error("Url Mappings Error - [" + type + "]: " + message);
};
//# sourceMappingURL=errors.js.map